import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Document } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"

import DocumentForm from "./DocumentForm"
import { useCreateDocument } from "../../hooks/documents"
import { initialValuesDocument, validationSchemaDocument } from "./DocumentCommon"

export default function DocumentCreate() {
  const createDocument = useCreateDocument()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesDocument(), [])
  const validationSchema = useMemo(() => validationSchemaDocument(), [])

  useBreadcrumbs([{ label: "Documenti", href: "/documents/documents" }, { label: "Creazione Documento" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo documento</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createDocument.mutateAsync(values as Document).then((document) => {
                navigate(`/documents/documents/${document.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <DocumentForm />
                </Container>
                <BottomFormFixed url="/documents/documents" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
